// src/pages/misc/public/wa.ts
// [HANDOFF] The one place with Ventaje's WhatsApp number (digits only, country code first, no "+", for wa.me links). WA_DISPLAY is the
//   pretty version shown on screen. Used by ContactPage.tsx. [VERIFY] The menu's "Abrir WhatsApp" button (landing/LandingMenu.tsx,
//   contact view) uses the bare https://wa.me/ with no number and does not read this file. The landing's floating bubble goes to /contacto.
export const WA_PHONE = '529995427336';
export const WA_DISPLAY = '+52 999 542 7336';

export function waLink(text: string): string {
  return `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(text)}`;
}

/** Title line goes bold in WhatsApp (*like this*). */
export function waText(title: string, body: string): string {
  const head = title.trim();
  const rest = body.trim();
  if (head && rest) return `*${head}*\n\n${rest}`;
  if (head) return `*${head}*`;
  return rest;
}

// ---------------------------------------------------------------------------------------------------------------------
// PARTNER PROGRAM (SociosPage.tsx)
// [UI-BACKEND-TODO] Today a partner lead is handed to Michael by opening wa.me with the message already written. This will move to
//   the WhatsApp API (the server sends the message after saving the lead), so nothing opens in the visitor's browser. When that
//   happens, delete PARTNER_LEADS_WA / partnerLeadLink and send `partnerLeadMessage(...)` from the backend instead.
// ---------------------------------------------------------------------------------------------------------------------

/** Michael's WhatsApp, where every partner lead arrives. Digits only, country code first (52 + 10 digits). */
export const PARTNER_LEADS_WA = '529999149944';

/** Invite link of the partners' WhatsApp group.
 * [VERIFY] Consider a WhatsApp Community with an announcements channel instead: in a normal group every partner sees every
 * other partner's number. */
export const PARTNER_GROUP_URL = 'https://chat.whatsapp.com/GyR8qNLbHLY5qNW3i2Z3u5';

export interface PartnerInfo {
  name: string;
  whatsapp: string;
}

export interface PartnerLead {
  company: string;
  city: string | null;
  contact_name: string;
  contact_role: string | null;
  contact_whatsapp: string;
  /** appointment = $300 · lead = $150 */
  referral_type: 'lead' | 'appointment';
  appointment_when: string | null;
  how_known: string | null;
}

/** The lead written as a WhatsApp message (*bold* labels), one fact per line. */
export function partnerLeadMessage(p: PartnerLead, partner: PartnerInfo): string {
  const lines = [
    '*Nuevo lead de socio · Ventaje*',
    '',
    `*Socio:* ${partner.name} (${partner.whatsapp})`,
    `*Tipo:* ${p.referral_type === 'appointment' ? 'Ya agendé la cita ($300)' : 'Sólo el contacto ($150)'}`,
    '',
    `*Empresa:* ${p.company}${p.city ? ` · ${p.city}` : ''}`,
    `*Contacto:* ${p.contact_name}${p.contact_role ? ` · ${p.contact_role}` : ''}`,
    `*WhatsApp:* ${p.contact_whatsapp}`,
  ];
  if (p.appointment_when) lines.push(`*Cita:* ${p.appointment_when}`);
  if (p.how_known) lines.push(`*Cómo lo conoce:* ${p.how_known}`);
  lines.push('', '✓ El contacto sabe que Ventaje lo va a contactar.');
  return lines.join('\n');
}

export function partnerLeadLink(text: string): string {
  return `https://wa.me/${PARTNER_LEADS_WA}?text=${encodeURIComponent(text)}`;
}
